import * as ko from 'knockout';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { Modal } from 'Core/Common/Modal';
import { Event } from 'Core/Common/Event';

import { LABELS } from 'Core/Components/Translation/Locales';

import {
    IPropertyDescription,
    IPropertyOption,
    ISource,
} from '../../../GeneralProperties/Managers/BaseProperty';
import { ColorPicker } from '../../../GeneralProperties/Managers/ColorPicker/ColorPicker';
import { SelectProperty } from '../../../GeneralProperties/Managers/SelectProperty/SelectProperty';
import { CARD_SCREEN_PROPERTY_TYPE, PATH_RUNNER_MODE, SCREEN_PROPERTY_TYPE } from 'Core/Constant';
import {
    IWebSizeValue,
    WebSizeProperty,
} from '../../../GeneralProperties/Managers/WebSizeProperty/WebSizeProperty';
import { ScreenTypes } from 'Core/Common/Enums/ScreenTypes';

import { FormTypeModel } from '../../../Models/Screens/ScreenModel';
import { DesignScreen } from '../../../Screens/DesignScreen/DesignScreen';
import { Notifier } from 'Core/Common/Notifier';
import { PathRunnerStore } from 'Core/Components/PathRunner/Stores/PathRunnerStore';
import {
    IPathRunnerFieldOption,
    IPathRunnerTargetOption,
    IPathRunnerTypeOption,
    IPathRunnerViaOption,
} from 'Core/Components/PathRunner/Models/Response/PathRunnerPathOptionsModel';
import SettingsModalTemplate from 'Core/Controls/FormDesigner/SettingsModal/Templates/SettingsModal.html';
import PathLevelTemplate from 'Core/Controls/FormDesigner/SettingsModal/Templates/PathLevel.html';
ko.templates['Core/Controls/FormDesigner/SettingsModal/Templates/SettingsModal'] =
    SettingsModalTemplate;
ko.templates['Core/Controls/FormDesigner/SettingsModal/Templates/PathLevel'] = PathLevelTemplate;

export interface ISettingsModal {
    Type: string;
    Value?: any;
}

export interface IPathLevelRow {
    Entity: KnockoutObservable<string>;
    Via: KnockoutObservable<string>;
    DateField: KnockoutObservable<string>;
    Hidden: KnockoutObservable<boolean>;
    WithinRoot: KnockoutObservable<boolean>;
    TypeIds: KnockoutObservableArray<number>;
    Parent: IPathLevelRow | null;
    Source: IPathLevelRow | null;
    Container: KnockoutObservableArray<IPathLevelRow> | null;
    AllowNesting: boolean;
    Children: KnockoutObservableArray<IPathLevelRow>;
    EntityOptions: KnockoutComputed<IPathRunnerTargetOption[]>;
    ViaOptions: KnockoutComputed<IPathRunnerViaOption[]>;
    ViaCaption: KnockoutComputed<string | undefined>;
    TypeOptions: KnockoutComputed<IPathRunnerTypeOption[]>;
    DateFieldOptions: KnockoutComputed<IPathRunnerFieldOption[]>;
}
export class SettingsModal extends Event {
    private _modal = new Modal(
        {
            addClass: 'settings-modal jBox-no-padding',
            width: '500',
            height: '70vh',
            isolateScroll: false,
            onOpen: () => {
                const container = this._modal.Container();
                const jBoxContent = $(container)
                    .addClass('bg-muted!')
                    .find('.jBox-content')
                    ?.removeClass('sps-scrollable-y')
                    .addClass('!overflow-hidden');

                jBoxContent.find('div').first().addClass('h-full');
            },
        },
        false
    );

    _labels = LABELS;

    private _bgColorCardScreen: ColorPicker;
    private _widthCardScreen: WebSizeProperty;
    private _fontColorCardScreen: ColorPicker;
    private _fontWeightCardScreen: SelectProperty;
    private _fontFamilyCardScreen: SelectProperty;
    private _fontStyleCardScreen: SelectProperty;
    private _params: KnockoutObservableArray<ISettingsModal>;

    private _fontStyleOptions: KnockoutObservable<any>;
    private _fontFamily: KnockoutObservable<string>;
    private _fontColor: KnockoutObservable<string>;
    private _fontWeight: KnockoutObservable<string>;
    private _fontStyle: KnockoutObservable<string>;
    private _styleText: KnockoutObservable<any>;
    private _screenType: string;
    private _screenTypes: KnockoutObservableArray<FormTypeModel>;
    private _selectedType: KnockoutObservable<FormTypeModel>;
    private _screenBackgroundColor: ColorPicker;
    private _screenHeaderBackgroundColor: ColorPicker;
    private _screenBGColor: KnockoutObservable<string>;
    private _screenHeaderBGColor: KnockoutObservable<string>;
    private _designScreen: DesignScreen;
    private _pathRunnerToggler: KnockoutObservable<boolean>;
    private _isEnablePathRunnerToggler: KnockoutObservable<boolean>;
    private _isCardScreen: boolean;
    private _showGeneralSettings: boolean;
    private _pathLevels: KnockoutObservableArray<IPathLevelRow>;
    private _pathMode: KnockoutObservable<string>;
    private _isGroupMode: KnockoutComputed<boolean>;
    private _pathBase: KnockoutObservable<IPathLevelRow>;
    private _pathGroups: KnockoutObservableArray<IPathLevelRow>;
    private _isPathConfigVisible: KnockoutComputed<boolean>;
    private _pathTargets: KnockoutObservableArray<IPathRunnerTargetOption>;
    private _pathTargetsByEntity: KnockoutObservable<{ [entityId: number]: IPathRunnerTargetOption[] }>;
    private _pathTargetsRequested: { [entityId: number]: boolean };

    constructor(
        params: Array<ISettingsModal>,
        screenType: string,
        screenTypes: KnockoutObservableArray<FormTypeModel>,
        selectedType: KnockoutObservable<FormTypeModel>,
        designScreen: DesignScreen
    ) {
        super();
        this._screenType = screenType;
        this._screenTypes = ko.observableArray([]);
        this._selectedType = ko.observable(null);

        this._fontStyleOptions = ko.observable(null);
        this._fontColor = ko.observable(null);
        this._fontFamily = ko.observable(null);
        this._fontWeight = ko.observable(null);
        this._fontStyle = ko.observable(null);
        this._styleText = ko.observable(null);
        this._screenBGColor = ko.observable(null);
        this._screenHeaderBGColor = ko.observable(null);
        this._designScreen = null;
        this._pathRunnerToggler = ko.observable(false);
        this._isEnablePathRunnerToggler = ko.observable(false);
        this._pathLevels = ko.observableArray([]);
        this._pathMode = ko.observable(PATH_RUNNER_MODE.PATH);
        this._isGroupMode = ko.computed(() => this._pathMode() === PATH_RUNNER_MODE.GROUP);
        this._pathBase = ko.observable(null);
        this._pathGroups = ko.observableArray([]);
        this._pathTargets = ko.observableArray([]);
        this._pathTargetsByEntity = ko.observable({});
        this._pathTargetsRequested = {};
        this._isPathConfigVisible = ko.computed(
            () => this._isEnablePathRunnerToggler() && this._pathRunnerToggler()
        );
        this._isCardScreen = this._screenType === ScreenTypes[ScreenTypes.CardScreen];
        this._showGeneralSettings = this._screenType === ScreenTypes[ScreenTypes.ConsultScreen]
            ||
            this._screenType === ScreenTypes[ScreenTypes.EditScreen]
            ||
            this._screenType === ScreenTypes[ScreenTypes.ListScreen]
            ||
            this._screenType === ScreenTypes[ScreenTypes.Dashboard]
            ||
            this._screenType === ScreenTypes[ScreenTypes.SpecialScreen];

        this._params = ko.observableArray(params);
        this.InitSettingControls(params, screenTypes, selectedType, designScreen);
    }

    InitSettingControls(
        params: Array<ISettingsModal>,
        screenTypes: KnockoutObservableArray<FormTypeModel>,
        selectedType: KnockoutObservable<FormTypeModel>,
        designScreen: DesignScreen
    ): void {
        this._screenTypes(screenTypes());
        this._selectedType = ko.observable(selectedType());
        this._designScreen = designScreen;
        this._isEnablePathRunnerToggler(this._designScreen.IsConsultScreen);
        this.InitPathRunnerToggler();
        this.InitPathConfig(params);

        if (this._isCardScreen) {
            this.InitWidthCardScreen(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.SCREEN_WIDTH)?.Value
            );
            this.InitBackgroundColorScreen(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.SCREEN_BACKGROUND_COLOR)
                    ?.Value
            );
            this.InitFontColor(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.FONT_COLOR)?.Value
            );
            this.InitFontWeight(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.FONT_WEIGHT)?.Value
            );
            this.InitFontFamily(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.FONT_FAMILY)?.Value
            );
            this.InitFontStyle(
                this.FindElementByType(params, CARD_SCREEN_PROPERTY_TYPE.FONT_STYLE)?.Value
            );
        } else {
            this.InitScreenBGColor(
                this.FindElementByType(params, SCREEN_PROPERTY_TYPE.SCREEN_BACKGROUND_COLOR)?.Value
            );
            this.InitScreenHeaderBGColor(
                this.FindElementByType(params, SCREEN_PROPERTY_TYPE.SCREEN_HEADER_BACKGROUND_COLOR)
                    ?.Value
            );
        }
    }

    InitPathRunnerToggler() {
        if (this._designScreen.IsEnablePathRunner) {
            this._pathRunnerToggler(true);
        } else {
            this._pathRunnerToggler(false);
        }
    }

    InitPathConfig(params: Array<ISettingsModal>) {
        const value = this.FindElementByType(params, SCREEN_PROPERTY_TYPE.PATH_RUNNER_PATH)?.Value;

        this._pathLevels(
            (value?.Levels || []).map((level: any) => this.CreatePathLevel(level))
        );

        this._pathMode(
            value?.Mode === PATH_RUNNER_MODE.GROUP ? PATH_RUNNER_MODE.GROUP : PATH_RUNNER_MODE.PATH
        );
        const base = this.CreatePathLevel(value?.Base, null, null, false);

        this._pathBase(base);
        this._pathGroups(
            (value?.GroupBy || []).map((level: any) =>
                this.CreatePathLevel(level, base, this._pathGroups, false)
            )
        );

        if (!this._isEnablePathRunnerToggler()) {
            return;
        }

        PathRunnerStore.GetPathOptions(this._designScreen.GetEntityId())
            .then((options) => {
                this._pathTargets(options?.Targets || []);
            })
            .fail((error) => new Notifier().Failed(error.message));
    }

    AddPathLevel() {
        this._pathLevels.push(this.CreatePathLevel());
    }

    AddGroupLevel() {
        this._pathGroups.push(
            this.CreatePathLevel(undefined, this._pathBase(), this._pathGroups, false)
        );
    }

    AddChildPathLevel(parent: IPathLevelRow) {
        parent.Children.push(this.CreatePathLevel(undefined, parent));
    }

    RemovePathLevel(level: IPathLevelRow) {
        this.ContainerOf(level).remove(level);
    }

    MovePathLevel(level: IPathLevelRow, offset: number) {
        const container = this.ContainerOf(level);
        const levels = container();
        const index = levels.indexOf(level);
        const target = index + offset;

        if (index === -1 || target < 0 || target >= levels.length) {
            return;
        }

        container.splice(index, 1);
        container.splice(target, 0, level);
    }

    private ContainerOf(level: IPathLevelRow): KnockoutObservableArray<IPathLevelRow> {
        if (level.Container) {
            return level.Container;
        }

        return level.Parent ? level.Parent.Children : this._pathLevels;
    }

    private CreatePathLevel(
        level?: any,
        parent: IPathLevelRow | null = null,
        container: KnockoutObservableArray<IPathLevelRow> | null = null,
        allowNesting = true
    ): IPathLevelRow {
        const entity: KnockoutObservable<string> = ko.observable(level?.Entity || '');
        const via: KnockoutObservable<string> = ko.observable(level?.Via || '');
        const dateField: KnockoutObservable<string> = ko.observable(level?.DateField || '');
        const hidden: KnockoutObservable<boolean> = ko.observable(!!level?.Hidden);
        const withinRoot: KnockoutObservable<boolean> = ko.observable(!!level?.WithinRoot);
        const typeIds: KnockoutObservableArray<number> = ko.observableArray(
            (level?.TypeIds || []).map((id: any) => Number(id)).filter((id: number) => !isNaN(id))
        );

        const row: Partial<IPathLevelRow> = {
            Entity: entity,
            Via: via,
            DateField: dateField,
            Hidden: hidden,
            WithinRoot: withinRoot,
            TypeIds: typeIds,
            Parent: parent,
            Container: container,
            AllowNesting: allowNesting,
        };

        const entityOptions = ko.computed(() => this.GetLevelTargets(row as IPathLevelRow));
        const target = () => _.find(entityOptions(), (item) => item.Name === entity());
        const viaOptions = ko.computed(() => target()?.ViaOptions || []);
        const viaCaption = ko.computed(() =>
            target()?.IsDriver ? '(the row itself)' : undefined
        );
        const typeOptions = ko.computed(() => target()?.Types || []);
        const dateFieldOptions = ko.computed(() => target()?.DateFields || []);

        entity.subscribe(() => {
            if (!_.find(viaOptions(), (option) => option.Name === via())) {
                via('');
            }
            const allowed = _.map(typeOptions(), (type) => type.Id);
            typeIds(_.filter(typeIds(), (id) => allowed.indexOf(id) !== -1));
            if (!_.find(dateFieldOptions(), (option) => option.Name === dateField())) {
                dateField('');
            }
        });

        row.EntityOptions = entityOptions;
        row.ViaOptions = viaOptions;
        row.ViaCaption = viaCaption;
        row.TypeOptions = typeOptions;
        row.DateFieldOptions = dateFieldOptions;
        row.Children = ko.observableArray(
            (level?.Children || []).map((child: any) => this.CreatePathLevel(child, row as IPathLevelRow))
        );

        return row as IPathLevelRow;
    }

    private GetLevelTargets(row: IPathLevelRow): IPathRunnerTargetOption[] {
        if (!row.Parent) {
            return this._pathTargets();
        }

        const parentTarget = _.find(
            this.GetLevelTargets(row.Parent),
            (item) => item.Name === row.Parent.Entity()
        );
        if (!parentTarget) {
            return [];
        }

        this.EnsureEntityTargets(parentTarget.EntityId);

        return this._pathTargetsByEntity()[parentTarget.EntityId] || [];
    }

    private EnsureEntityTargets(entityId: number) {
        if (!entityId || this._pathTargetsRequested[entityId]) {
            return;
        }

        this._pathTargetsRequested[entityId] = true;

        PathRunnerStore.GetPathOptions(entityId)
            .then((options) => {
                const cache = this._pathTargetsByEntity();
                cache[entityId] = options?.Targets || [];
                this._pathTargetsByEntity(cache);
            })
            .fail((error) => new Notifier().Failed(error.message));
    }

    private BuildPathOption(): ISettingsModal | null {
        const serializeLevels = (rows: IPathLevelRow[]): any[] =>
            rows
                .map((level) => {
                    const serialized: any = {
                        Entity: (level.Entity() || '').trim(),
                        Via: (level.Via() || '').trim(),
                        TypeIds: _.filter(level.TypeIds() || [], (id) => !isNaN(id)),
                        Children: serializeLevels(level.Children()),
                    };

                    const dateField = (level.DateField() || '').trim();

                    if (dateField.length) {
                        serialized.DateField = dateField;
                    }
                    if (level.Hidden()) {
                        serialized.Hidden = true;
                    }
                    if (level.WithinRoot()) {
                        serialized.WithinRoot = true;
                    }

                    return serialized;
                })
                .filter((level) => !!level.Entity.length);

        if (this._isGroupMode()) {
            const base = this._pathBase();
            const baseLevels = base ? serializeLevels([base]) : [];
            const groups = serializeLevels(this._pathGroups());

            if (!baseLevels.length || !groups.length) {
                return null;
            }

            return {
                Type: SCREEN_PROPERTY_TYPE.PATH_RUNNER_PATH,
                Value: {
                    Mode: PATH_RUNNER_MODE.GROUP,
                    Base: baseLevels[0],
                    GroupBy: groups,
                },
            };
        }

        const levels = serializeLevels(this._pathLevels());

        if (!levels.length) {
            return null;
        }

        return {
            Type: SCREEN_PROPERTY_TYPE.PATH_RUNNER_PATH,
            Value: { Levels: levels },
        };
    }

    private MergeOptions(screenOptions: Array<ISettingsModal>): Array<ISettingsModal> {
        const existing: Array<ISettingsModal> = this._params() || [];
        const handledTypes: Array<string> = _.map(screenOptions, (option) => option.Type);
        const pathOption = this._isPathConfigVisible() ? this.BuildPathOption() : null;

        if (this._isPathConfigVisible()) {
            handledTypes.push(SCREEN_PROPERTY_TYPE.PATH_RUNNER_PATH);
        }

        const merged = _.filter(
            existing,
            (option: ISettingsModal) => handledTypes.indexOf(option.Type) === -1
        ).concat(screenOptions);

        if (pathOption) {
            merged.push(pathOption);
        }

        return merged;
    }

    FindElementByType(array: ISettingsModal[], type: string): ISettingsModal | undefined {
        return _.find(array, { Type: type });
    }

    InitWidthCardScreen(value?: IWebSizeValue) {
        let propertyValue: IWebSizeValue | undefined = value,
            options: Array<IPropertyOption> = [
                { Name: '%', Value: '%' },
                { Name: 'px', Value: 'px' },
            ],
            defaultOptions: IPropertyOption = { Name: '%', Value: '%' },
            property: IPropertyDescription = {
                Name: 'Screen Width',
                Type: CARD_SCREEN_PROPERTY_TYPE.SCREEN_WIDTH,
                PropertyManager: 'WebSizeProperty',
                ValueRequired: false,
                Options: options,
                Source: null,
                DefaultValue: defaultOptions,
            };

        this._widthCardScreen = new WebSizeProperty(property, propertyValue);
    }

    InitBackgroundColorScreen(value?: string) {
        let propertyValue: string | undefined = value,
            property: IPropertyDescription = {
                Name: 'Background Color',
                Type: CARD_SCREEN_PROPERTY_TYPE.SCREEN_BACKGROUND_COLOR,
                PropertyManager: 'ColorPicker',
                ValueRequired: false,
                Options: null,
                Source: null,
            };

        this._bgColorCardScreen = new ColorPicker(property, propertyValue);
    }

    InitFontColor(value?: string) {
        let propertyValue: string | undefined = value,
            property: IPropertyDescription = {
                Name: 'Font Color',
                Type: CARD_SCREEN_PROPERTY_TYPE.FONT_COLOR,
                PropertyManager: 'ColorPicker',
                ValueRequired: false,
                Options: null,
                Source: null,
            };

        this._fontColorCardScreen = new ColorPicker(property, propertyValue);
        this._styleText(propertyValue ? { color: propertyValue } : null);
    }

    InitFontWeight(value?: IPropertyOption) {
        let getData = null,
            propertyValue: IPropertyOption | undefined = value,
            options: Array<IPropertyOption> = [
                { Name: 'Light', Value: 'font-light' },
                { Name: 'Regular', Value: 'font-regular' },
                { Name: 'Medium', Value: 'font-medium' },
                { Name: 'Bold', Value: 'font-bold' },
                { Name: 'Black', Value: 'font-black' },
            ],
            property: IPropertyDescription = {
                Name: 'Font Weight',
                Type: CARD_SCREEN_PROPERTY_TYPE.FONT_WEIGHT,
                PropertyManager: 'SelectProperty',
                ValueRequired: false,
                Options: options,
                Source: null,
            };

        this._fontWeightCardScreen = new SelectProperty(property, propertyValue, getData);
        this._fontWeight(propertyValue?.Value);
    }

    InitFontFamily(value?: IPropertyOption) {
        // add new font:
        // 1. https://fonts.google.com/selection/embed
        // 2. update <link href="https://fonts.googleapis.com/css2?family=...  on _Layout.cshtml
        // 2. update @mixin customFontFamily on _mixins.scss
        // 3. update options
        let getData = null,
            propertyValue: IPropertyOption | undefined = value,
            options: Array<IPropertyOption> = [
                { Name: 'Roboto', Value: 'roboto-font' },
                { Name: 'Lato', Value: 'lato-font' },
                { Name: 'Poppins', Value: 'poppins-font' },
                { Name: 'Inria Sans', Value: 'inria-sans-font' },
                { Name: 'Ubuntu', Value: 'ubuntu-font' },
                { Name: 'Fira Sans', Value: 'fira-sans-font' },
                { Name: 'Titillium Web', Value: 'titillium-web-font' },
            ],
            property: IPropertyDescription = {
                Name: 'Font Family',
                Type: CARD_SCREEN_PROPERTY_TYPE.FONT_FAMILY,
                PropertyManager: 'SelectProperty',
                ValueRequired: false,
                Options: options,
                Source: null,
            };

        this._fontFamilyCardScreen = new SelectProperty(property, propertyValue, getData);
        this._fontFamily(propertyValue?.Value);
    }

    InitFontStyle(value?: IPropertyOption) {
        let getData = null,
            propertyValue: IPropertyOption | undefined = value,
            options: Array<IPropertyOption> = [
                { Name: 'Normal', Value: 'font-normal' },
                { Name: 'Italic', Value: 'font-italic' },
            ],
            property: IPropertyDescription = {
                Name: 'Font Style',
                Type: CARD_SCREEN_PROPERTY_TYPE.FONT_STYLE,
                PropertyManager: 'SelectProperty',
                ValueRequired: false,
                Options: options,
                Source: null,
            };

        this._fontStyleCardScreen = new SelectProperty(property, propertyValue, getData);
        this._fontStyle(propertyValue?.Value);
    }

    InitScreenBGColor(value?: string) {
        let propertyValue: string | undefined = value,
            property: IPropertyDescription = {
                Name: 'Screen Background Color',
                Type: SCREEN_PROPERTY_TYPE.SCREEN_BACKGROUND_COLOR,
                PropertyManager: 'ColorPicker',
                ValueRequired: false,
                Options: null,
                Source: null,
            };

        this._screenBackgroundColor = new ColorPicker(property, propertyValue);
        this._screenBGColor(propertyValue ? propertyValue : null);
    }

    InitScreenHeaderBGColor(value?: string) {
        let propertyValue: string | undefined = value,
            property: IPropertyDescription = {
                Name: 'Screen Header Background Color',
                Type: SCREEN_PROPERTY_TYPE.SCREEN_HEADER_BACKGROUND_COLOR,
                PropertyManager: 'ColorPicker',
                ValueRequired: false,
                Options: null,
                Source: null,
            };

        this._screenHeaderBackgroundColor = new ColorPicker(property, propertyValue);
        this._screenHeaderBGColor(propertyValue ? propertyValue : null);
    }

    Show() {
        ko.cleanNode(this._modal.Wrapper);
        ko.applyBindings(this, this._modal.Wrapper);
        this._modal.Show();
    }

    OnSubmit() {
        let screenOptions: Array<ISettingsModal> = null;

        if (this._isCardScreen) {
            screenOptions = [
                {
                    Type: this._bgColorCardScreen.PropertyDescriptionType,
                    Value: this._bgColorCardScreen.Value(),
                },
                {
                    Type: this._widthCardScreen.PropertyDescriptionType,
                    Value: this._widthCardScreen.Value(),
                },
                {
                    Type: this._fontColorCardScreen.PropertyDescriptionType,
                    Value: this._fontColorCardScreen.Value(),
                },
                {
                    Type: this._fontFamilyCardScreen.PropertyDescriptionType,
                    Value: this._fontFamilyCardScreen.Value(),
                },
                {
                    Type: this._fontWeightCardScreen.PropertyDescriptionType,
                    Value: this._fontWeightCardScreen.Value(),
                },
                {
                    Type: this._fontStyleCardScreen.PropertyDescriptionType,
                    Value: this._fontStyleCardScreen.Value(),
                },
            ];
        } else {
            screenOptions = [
                {
                    Type: this._screenBackgroundColor.PropertyDescriptionType,
                    Value: this._screenBackgroundColor.Value(),
                },
                {
                    Type: this._screenHeaderBackgroundColor.PropertyDescriptionType,
                    Value: this._screenHeaderBackgroundColor.Value(),
                },
            ];
        }

        // let hasChanges: boolean = !_.isEqual(screenOptions, this._params());
        let hasChanges: boolean = true;

        this.Trigger('SUBMIT', {
            Options: this.MergeOptions(screenOptions || []),
            HasChanges: hasChanges,
            SelectedType: this._selectedType,
        });

        this._modal.Close();
    }

    GetTemplateName() {
        return 'Core/Controls/FormDesigner/SettingsModal/Templates/SettingsModal';
    }

    AfterRender() {
        if (this._isCardScreen) {
            this._fontFamilyCardScreen.Value.subscribe((newValue) => {
                this._fontFamily(newValue.Value);
            });
            this._fontWeightCardScreen.Value.subscribe((newValue) => {
                this._fontWeight(newValue.Value);
            });
            this._fontStyleCardScreen.Value.subscribe((newValue) => {
                this._fontStyle(newValue.Value);
            });
            this._fontColorCardScreen.Value.subscribe((newValue) => {
                this._fontColor(newValue);
                this._styleText({ color: this._fontColor() });
            });
            this._fontFamily.subscribe((newValue) => {
                this._fontStyleOptions(
                    `${this._fontFamily()} ${this._fontWeight()} ${this._fontStyle()}`
                );
            });
            this._fontWeight.subscribe((newValue) => {
                this._fontStyleOptions(
                    `${this._fontFamily()} ${this._fontWeight()} ${this._fontStyle()}`
                );
            });
            this._fontStyle.subscribe((newValue) => {
                this._fontStyleOptions(
                    `${this._fontFamily()} ${this._fontWeight()} ${this._fontStyle()}`
                );
            });

            this._fontStyleOptions(
                `${this._fontFamily()} ${this._fontWeight()} ${this._fontStyle()}`
            );
        } else {
            const testScreenBodyHeader: JQuery<HTMLElement> = $(document.body).find(
                '.test-screen_body__header'
            );
            const testScreenBodyPageContainer: JQuery<HTMLElement> = $(document.body).find(
                '.test-screen_body__page-container'
            );

            this._screenBackgroundColor.Value.subscribe((newValue) => {
                this._screenBGColor(newValue);
                $(testScreenBodyPageContainer)
                    .get(0)
                    .style.setProperty('--page-bg-color', newValue);
            });
            this._screenHeaderBackgroundColor.Value.subscribe((newValue) => {
                this._screenHeaderBGColor(newValue);
                $(testScreenBodyHeader).get(0).style.setProperty('--main-color-1', newValue);
            });

            if (this._screenBGColor()) {
                const testScreenBodyPageContainer: JQuery<HTMLElement> = $(document.body).find(
                    '.test-screen_body__page-container'
                );
                $(testScreenBodyPageContainer)
                    .get(0)
                    .style.setProperty('--page-bg-color', this._screenBGColor());
            }
            if (this._screenHeaderBGColor()) {
                const testScreenBodyHeader: JQuery<HTMLElement> = $(document.body).find(
                    '.test-screen_body__header'
                );
                $(testScreenBodyHeader)
                    .get(0)
                    .style.setProperty('--main-color-1', this._screenHeaderBGColor());
            }
        }
    }

    get ScreenTypes() {
        return this._screenTypes;
    }

    PickType(formId, $data) {
        $data.IsMain = true;
        this._selectedType($data);
    }

    TogglePathRunner() {
        this.Trigger('TogglePathRunner');
        this.InitPathRunnerToggler();
    }
}
